class PromoBannerSlider {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('.promo-banner-slider__track');
    this.slides = Array.from(el.querySelectorAll('.promo-banner-slide'));
    this.dots = Array.from(el.querySelectorAll('.promo-banner-slider__dot'));

    this.autoplay = el.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(el.dataset.autoplaySpeed, 10) || 5000;
    this.transitionSpeed = parseInt(el.dataset.transitionSpeed, 10) || 600;

    this.current = 0;
    this.timer = null;

    if (!this.slides.length) return;

    this.track.style.setProperty('--pbs-transition-speed', `${this.transitionSpeed}ms`);

    this.bindEvents();
    this.goTo(0, false);

    if (this.slides.length > 1 && this.autoplay) this.startAutoplay();
  }

  bindEvents() {
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(parseInt(dot.dataset.index, 10));
        this.restartAutoplay();
      });
    });

    if (this.slides.length > 1) {
      this.el.addEventListener('mouseenter', () => this.stopAutoplay());
      this.el.addEventListener('mouseleave', () => {
        if (this.autoplay) this.startAutoplay();
      });

      let startX = 0;
      let isDragging = false;

      this.track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
        this.stopAutoplay();
      }, { passive: true });

      this.track.addEventListener('touchend', (e) => {
        if (!isDragging) return;
        isDragging = false;
        const endX = e.changedTouches[0].clientX;
        const diff = startX - endX;
        const threshold = 40;

        if (diff > threshold) {
          this.goTo(this.current + 1);
        } else if (diff < -threshold) {
          this.goTo(this.current - 1);
        }
        if (this.autoplay) this.startAutoplay();
      });
    }
  }

  goTo(index, animate = true) {
    const total = this.slides.length;
    this.current = (index + total) % total;

    this.track.style.transition = animate
      ? `transform ${this.transitionSpeed}ms ease-in-out`
      : 'none';
    this.track.style.transform = `translateX(-${this.current * 100}%)`;

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.current);
    });
  }

  startAutoplay() {
    this.stopAutoplay();
    this.timer = setInterval(() => {
      this.goTo(this.current + 1);
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  restartAutoplay() {
    if (this.autoplay) this.startAutoplay();
  }
}

function initPromoBannerSliders() {
  document.querySelectorAll('.promo-banner-slider').forEach((el) => {
    if (!el.dataset.initialized) {
      el.dataset.initialized = 'true';
      new PromoBannerSlider(el);
    }
  });
}

document.addEventListener('DOMContentLoaded', initPromoBannerSliders);

// Soporte para el editor de temas de Shopify (recarga de secciones)
document.addEventListener('shopify:section:load', (e) => {
  const el = e.target.querySelector('.promo-banner-slider');
  if (el) {
    el.dataset.initialized = 'true';
    new PromoBannerSlider(el);
  }
});